import {
  EmailMarketingRouteComponent,
  loadEmailMarketingRoute,
} from '../settings/email-marketing/index'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$orgId/marketing/')({
  component: EmailMarketingRouteComponent,
  loader: loadEmailMarketingRoute,
})
